// BuyReport.js
// Component for the Buy Report

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import ReportCard from './ReportCard';
import OrderSelect from './OrderSelect';
import dateFormat from 'dateformat';

// Component Class
// Shows Buy Report Card
class BuyReport extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      order: null,
    }
  }

  // Returns the filename for the downloaded report
  getFilename = () => {
    var order = this.state.order;
    var date = order && order.dateClosed ? new Date(order.dateClosed) : new Date();
    var dateStr = dateFormat(date, "yyyy.mm.dd");
    return "Carlinhos_Compras_"+dateStr+".pdf"
  }

  // Returns the processed report object
  getReport = () => {
    return this.props.report.getBuyReport(this.state.order);
  }

  // Sets the current order to generate reports for
  setOrder = (order) => {
    this.setState({order: order});
  }

  // Renders Component
  render() {
    return (
      <ReportCard
        title="Resumo de Compras"
        description="Lista de produtos a comprar, baseado em todos os pedidos de uma data."
        getReport={this.getReport}
        getFilename={this.getFilename}
      >
        <center>
          <OrderSelect
            orders={this.props.orders}
            selected={this.state.order}
            setOrder={this.setOrder}
          />
        </center>
        <br />
      </ReportCard>
    );
  }
}

// Required Properties
BuyReport.propTypes = {
  report: PropTypes.object.isRequired,
  orders: PropTypes.object.isRequired,
}

// Exports
export default BuyReport;


// WEBPACK FOOTER //
// ./src/components/ReportView/BuyReport.js